export default __webpack_public_path__ + "static/media/match.e5109d86.svg";